import { Component, OnInit, ViewChild ,AfterViewInit, ViewChildren, PipeTransform, Pipe, Injectable, Directive, Inject, Input} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {GestureConfig} from 'owl-ng'
import { DateAdapter } from "@angular/material/core";
import {
  MatDateRangeSelectionStrategy,
  DateRange,
  MatDatepicker,
  MatDateRangePicker,
  MAT_DATE_RANGE_SELECTION_STRATEGY,
  MatDatepickerInputEvent
} from "@angular/material/datepicker";

import Swal from 'sweetalert2/dist/sweetalert2.js'
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

import { PDFfile } from 'src/app/device/PDFfile';
import { Router } from '@angular/router';
import { TraslateService } from 'src/app/traslate.service';
import { NgxSpinnerService } from 'ngx-spinner';
import 'hammerjs';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexFill,
  ApexXAxis,
  ApexDataLabels,
  ApexYAxis,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexAnnotations,
  ApexStroke,
  ApexMarkers,
  ApexGrid,
  ApexLegend
} from "ng-apexcharts";
import { TooltipArea } from '@swimlane/ngx-charts';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { MatMenuTrigger } from '@angular/material/menu';


@Injectable()
export class MaxRangeSelectionStrategy<D>
  implements MatDateRangeSelectionStrategy<D> {
  start: any;
  public delta: number;
  constructor(private _dateAdapter: DateAdapter<D>) {}

  selectionFinished(date: D, currentRange: DateRange<D>) {
    let { start, end } = currentRange;
    if (start == null || (start && end)) {
      start = date;
      end = null;
    } else if (end == null) {
      const maxDate = this._dateAdapter.addCalendarDays(start, this.delta);
      end = date ? (date > maxDate ? maxDate : date) : null;
    }

    return new DateRange<D>(start, end);
  }
  createPreview(
    activeDate: D | null,
    currentRange: DateRange<D>
  ): DateRange<D> {
    if (currentRange.start && !currentRange.end) {
      const maxDate = this._dateAdapter.addCalendarDays(
        currentRange.start,
        this.delta
      );
      const rangeEnd = activeDate
        ? activeDate > maxDate
          ? maxDate
          : activeDate
        : null;

      return new DateRange(currentRange.start, rangeEnd);
    }

    return new DateRange<D>(null, null);
  }
}

@Directive({
  selector: "[maxRange]",
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: MaxRangeSelectionStrategy
    }
  ]
})
export class MaxRangeDirective {
  constructor(
    @Inject(MAT_DATE_RANGE_SELECTION_STRATEGY)
    private maxRangeStrategy: MaxRangeSelectionStrategy<any>
  ) {}
  @Input() set maxRange(value: number) {
    this.maxRangeStrategy.delta = +value || 7;
  }
}


@Pipe({name: 'formatTime'})
export class FormatTime implements PipeTransform {
  transform(value: number): string {
    let minutes: number = Math.trunc(value/60);
    let hours: number = 0;
    let seconds: number = value - (minutes*60);

    if (minutes >= 60) {
      hours = Math.trunc(minutes/60);
      minutes = minutes - (hours*60);
    }

    let response: string = "";

    if (hours > 0) {
      response = response + hours + " h ";
    }

    if (minutes > 0) {
      response = response + minutes + " min ";
    }

    if (seconds > 0) {
      response = response + seconds + " sec";
    }

    return response;
}
}
export interface dataRep2 {

  value: number;
}


export type ChartOptions = {
  series: any;
  chart: any;
  xaxis: any;
  yaxis: any;
  title: any;
  fill: any;
  dataLabels: any;
  tooltips:any;
  annotations:any;
  stroke: any;
  markers: any;
  colors: string[];
   grid: any;
  legend: any;
 };


export interface dataScore {
  name: string;
  x: number;
  y: number;
  z: number;
}


export interface dataRep {

  label: number;
  value: number;

}















@Component({
  selector: 'app-user-conducteur',
  templateUrl: './user-conducteur.component.html',
  styleUrls: ['./user-conducteur.component.scss']
})
export class UserConducteurComponent implements OnInit {


  minDate: Date = new Date (2010, 1, 1);
  maxDate: Date = new Date ();

  myModel = true;
  chartOptions16: any;
  chartOptions17: any;
  manualPage: number =0;
  pageSize1: any;
  pageSize = 5;
  lengthpage: number;
  pageNum: any ;
  manualPage1: number;
  lengthTotal: any;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [5, 10, 25, 100];
  public dateTime: Date
  index2:any =5;
  dd: any =0;
  pageSizeOptions1: number[];
  gg: any;
  itemSelect: any =[];
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  itemSelect2: any;
  hiddenContenu: string ='false';
  range: string;
  filterValue: string;
  repos2:PeriodicElementfilter[];
  URL: RequestInfo;
  refrech1: number =2017;
  dt: any;
  days: any;
  finalDate: any;
  hiddenDetails: boolean = false;
  dtformt:string = "M/d/yyyy"
  @ViewChild('paginator', {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  jj: string;
  tblhidden: string;
  typeMessage: string;
  dataSourcee: any;
  ELEMENT_DATAFILTER: PeriodicElementfilter[]
  dataSource: MatTableDataSource<PeriodicElementfilter> ;
  getdt: string;
  panelOpenState = false;
  repos: any;
  reposdt: any;
  ELEMENT_DATAFILTER2: any;
  URL2: string;
  currentScore: any;
  type9: string;
  width9: string;
  height9: string;
  dataSource9:any;
  dataFetch: (string | number)[][];

ELEMENTSCORE: dataScore[]
xValues: any;
series2: any[];
customColors2: any;
/*Graph */
@ViewChild("chart") chart: ChartComponent;



customColors: any;


chartOptions: any;
chartOptions2: any;
chartOptions3: any;

chartOptions4: any;
chartOptions5: any;

series1:any = [];
ff:any =null

series3: any= [];
series4: any= [];
fff: any= [];
vv: any;
  yValues: any;
  evolutionScoreEconomie: boolean = true;
  evolutionScoreSecurite: boolean = true;
  typeEvenement: boolean = true ;
  relationSecuriteEconomie: boolean = true;
  repartitionScoreSecurite: boolean = true;
  repartitionScoreEconomie: boolean = true;
  testFilter1: number;
  testFilter11: number;
  scoreS: any;
  scoreEc: any;
  distanceEntreMan: any;
  tmpinactivite: any;
  reposSc: any;
  sc_tnd_sec: any;
  sc_tnd_eco: any;
  min_dis_moy: any;
  dist_moy: any;
  max_dis_moy: any;
  min_vit_moy: any;
  max_vit_moy: any;
  vit_moy: any;
  rng: string;
  spinnerActive: boolean =false;

  listconducteure: any;
  veh: any;

  @ViewChild(MatMenuTrigger)
  contextMenu: MatMenuTrigger;

  contextMenuPosition = { x: '0px', y: '0px' };

  canvasWidth : any
  needleValue : any
  centralLabel : any
  name :any
  bottomLabel :any
  options_vit: { hasNeedle: boolean; needleColor: string; needleUpdateSpeed: number; arcColors: string[]; arcDelimiters: number[]; rangeLabel: string[]; needleStartValue: number; };
  options_dist: { hasNeedle: boolean; needleColor: string; needleUpdateSpeed: number; arcColors: string[]; arcDelimiters: number[]; rangeLabel: string[]; needleStartValue: number; };
  evo_sf_scores: any;
  evo_sf_score_cat: any;
  avg_evo_sf_score: any;
  reposChart: any;
  avg_evo_ec_score: any;
  evo_ec_scores: any;
  evo_ec_score_cat: any;
  reposRepartitionEC: any;
  reposRepartitionSF: any;
  unitsSF: any= [];
  reposRepartitionSF_avg: any;
  piePoint: any;
  pieStyle: any= [];
  pieColors: any =[];
  scoresSF: any =[];
  reposRepartitionEC_avg: any;
  unitsEC: any=[];
  scoresEC: any=[];
  pieStyleEC: any=[];
  pieColorsEC: any=[];
  reposRelationSF_EC: any;
  RelationEC_Avg: any;
  RelationSF_Avg: any;
  Relation_unitsEC_SF: any=[];
  series11: any[];
  chartOptionds: any= {
    series: [
      {
        name: "My-series",
        data: []
      }
    ],
    chart: {
      height: 400,
      type: "bar",
      width: '100%',
      dropShadow: {
        enabled: true,
        color: "#000",
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2
      },
      toolbar: {
        show: true
      }
    },
    colors:  ["#51B373"],
    // title: {
    //   text: "Répartition des types d'évènement"
    // },
    markers: {
      size: 6,
      hover: {
        size: 16
      }
    },
  }

  formatVitesse: (val: any) => string;
  formatDist: (val: any) => string;
  unitsVitesse: string ="Vitesse moy";

  view: any[] =[380, 280]
  legendDist: boolean =  false
legendPositionDist: string  ="below"
minDist:any=0
maxDist:any=0
colorSchemeDist: any ={
  domain: ["#5AA454"]
};
reposRepartitionTpEvents: any=[];
  result: any[];
;
singleDistance: { name: string; value: number; }[];


legendVitesse: boolean =  false
legendPositionVitesse: string ="below"
minVitesse:any=0
maxVitesse:any=0
colorSchemeVitesse: any ={
  domain: ["#fbb950"]
};
unitsDist:any ="Distance moy"
smallSegments:any=6
bigSegments:any=2
singleVitesse: { name: string; value: number; }[];
angleSpan:any =180
startAngle:any= -90


/* RepartionTypeEvent = [
  { name: "Accélération", value: 100 },
  { name: "Freinage", value: 50 },
  { name: "Virage", value: 85 },
  { name: "Excès de vitesse", value: 30 },
  { name: "Franchissement de ligne", value: 48 },
  { name: "Virage et freinage", value: 64 },
  { name: "Virage et accélération", value: 72 }
]; */






constructor(private _snackBar: MatSnackBar,private router: Router ,public traslateService: TraslateService, private http: HttpClient ,private spinnerVehiculeUser: NgxSpinnerService) {

 //this.getUserrefrech()


  this.series1=[];
  this.traslateService.obs.subscribe((response)=>{this.traslateService.maptoAtelier(response,this.series1);
  } );


//this.listconducteur()


this.executeFunction()


}





   goToBottom(e){
  }
   getchrt2(e,e2,avg){
    this.chartOptions5 = {
      series: [
        {
          name: '<img src="https://img.icons8.com/color/20/000000/natural-food.png"/> <b> Score économie </b>',
          data: e
        }
      ],
      chart: {
        height: '300px',
      width: '100%',
        type: "line",
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2
        },
        toolbar: {
          show: true
        }
      },
      colors: ["#1fb141", "#545454"],
      dataLabels: {
        enabled: true
      },
      stroke: {
        curve: "smooth"
      },

      title: {
        text: "",
        align: "left"
      },
      grid: {
        show: false ,
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0
        }
      },
    markers: {
      size: 6,
      hover: {
        size: 16
      }
    },
      xaxis: {
        type: "category",
        categories: e2
      },
      yaxis: {
        min: 0,
        max: 100,
        title: {
          text: "Score d'économie (%)"
        }
      }
      ,tooltip: {
        enabled: true,
        onDatasetHover: {
          highlightDataSeries: true,
        },  marker: {
          show: false,
        },
        y: {

          formatter:  (values)=> {
            return  values+' %   <img src="https://img.icons8.com/color/20/000000/average-value.png"/>  Moyenne: '+avg+'%';
          },
        }
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
        offsetY: -25,
        offsetX: -5
      }
      ,
    annotations: {
      yaxis: [
        {
          y: avg,
          borderColor: '#00E396',
          label: {
            borderColor: '#00E396',
            style: {
              color: '#fff',
              background: '#00E396'
            },
            text: 'Moyenne '+avg+'%'
          }
        }
      ]
    },

    };

   }


   getchrt3(e,e2,avg){
    this.chartOptions3 = {
      series: [
        {
          name: ' <img src="https://img.icons8.com/color/20/000000/warning-shield.png"/> <b> Score sécurité </b>',
          data: e
        }
      ],
      chart: {
        height: '300px',
      width: '100%',
        type: "line",
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2
        },
        toolbar: {
          show: true
        }
      },
      colors: ["#ffc107", "#545454"],
      dataLabels: {
        enabled: true
      },
      stroke: {
        curve: "smooth"
      },
      title: {
        text: "",
        align: "left"
      },
      grid: {
        show:false,
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0
        }
      },
      markers: {
        size: 6,
        hover: {
          size: 16
        }
      },
      xaxis: {
      //  type: "datetime",
     type: "category",
        categories: e2,

      },
      yaxis: {
        min: 0,
        max: 100,
        title: {
          text: "Score sécurité (%)"
        },

      }
      ,tooltip: {
        enabled: true,
        onDatasetHover: {
          highlightDataSeries: true,
        },  marker: {
          show: false,
        },
        y: {

          formatter:  (values)=> {
            return  values+' %  <img src="https://img.icons8.com/color/20/000000/average-value.png"/> Moyenne: '+avg+'%';
          },
        }
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
        offsetY: -25,
        offsetX: -5
      } ,
      annotations: {
        yaxis: [
          {
            y: avg,
            borderColor: '#00E396',
            label: {
              borderColor: '#00E396',
              style: {
                color: '#fff',
                background: '#00E396'
              },
              text: 'Moyenne '+avg+'%'
            }
          }
        ]
      },
    }

   }



   onContextMenu(event: MouseEvent, item: any) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = { 'item': item };
    this.contextMenu.menu.focusFirstItem('mouse');
    this.contextMenu.openMenu();

  }
ngOnInit(): void {

  this.updateManualPage2(this.index2);



}


showChartEvolutionScoreSecurite(){

  this.evolutionScoreSecurite=!this.evolutionScoreSecurite;
  this.goToBottom(1400)
}


showChartEvolutionScoreEconomie(){

  this.evolutionScoreEconomie=!this.evolutionScoreEconomie;
  this.goToBottom(1400)
}


showChartTypeEvenement(){

  this.typeEvenement=!this.typeEvenement;
  this.goToBottom(3000)
}


showChartRelationSecuriteEconomie(){

  this.relationSecuriteEconomie=!this.relationSecuriteEconomie;
  this.goToBottom(2400)
}

showChartRepartitionScoreSecurite(){

  this.repartitionScoreSecurite=!this.repartitionScoreSecurite;
  this.goToBottom(1900)
}

showChartRepartitionScoreEconomie(){

  this.repartitionScoreEconomie=!this.repartitionScoreEconomie;
  this.goToBottom(1900)
}

listconducteur(){

  const headerDict = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
  }

  const requestOptions = {
    headers: new HttpHeaders(headerDict),
  };
  this.spinnerActive =true
this.spinnerVehiculeUser.show();
    this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/scores/drivers/all' ,requestOptions).subscribe((response)=>{
      var listconducteur:any =response
      this.lengthTotal = listconducteur.length
      this.repos =  listconducteur.drivers
      this.dataSource = new MatTableDataSource(this.repos);
     this.dataSource.paginator = this.paginator;
     this.dataSource.sort = this.sort;
     this.spinnerVehiculeUser.hide();
     this.spinnerActive =false

     },
     (error) => {
       Swal.fire({
         text: 'Un problème est survenu! '+error,

       })
       this.spinnerVehiculeUser.hide();
       this.spinnerActive =false
     })


}




    getUserrefrech(){


    this.result = [];
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.spinnerActive =true
this.spinnerVehiculeUser.show();
//this.typeEvenement =false
      this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/scores/drivers/all' ,requestOptions).subscribe((response)=>{

        var listconducteur:any =response

        this.lengthTotal = listconducteur?.length
      this.reposSc=listconducteur
        this.repos =  listconducteur?.drivers
        this.reposRepartitionTpEvents=listconducteur?.global_repartition_events

    //Safety repos Repartition:

     this.reposRepartitionSF=listconducteur?.repartition_safety_score_chart?.repartition_safety_score
     this.reposRepartitionSF_avg=listconducteur?.repartition_safety_score_chart?.avg

    //Economy repos Repartition:

     this.reposRepartitionEC=listconducteur?.repartition_eco_score_chart?.repartition_eco_score
     this.reposRepartitionEC_avg=listconducteur?.repartition_eco_score_chart?.avg


     //Relation Safety-Economy score

     this.reposRelationSF_EC=listconducteur?.safety_eco_relation?.relation
     this.RelationEC_Avg=listconducteur?.safety_eco_relation?.avg_eco_score
     this.RelationSF_Avg=listconducteur?.safety_eco_relation?.avg_safety_score





      this.dataSource = new MatTableDataSource(this.repos);
       this.dataSource.paginator = this.paginator;
       this.dataSource.sort = this.sort;

    this.scoreS=this.reposSc?.global_safety_score
    this.scoreEc=this.reposSc?.global_eco_score
    this.distanceEntreMan= this.reposSc?.global_km_between_maneuvers
    this.tmpinactivite =this.reposSc?.global_idle_time
    this.sc_tnd_eco=this.reposSc?.global_eco_score_tendency
    this.sc_tnd_sec=this.reposSc?.global_safety_score_tendency

    this.dist_moy=this.reposSc?.global_avg_distance.avg_distance
    this.min_dis_moy=this.reposSc?.global_avg_distance.min
    this.max_dis_moy=this.reposSc?.global_avg_distance.max

    this.vit_moy=this.reposSc?.global_avg_speed.avg_speed
    this.min_vit_moy=this.reposSc?.global_avg_speed.min
    this.max_vit_moy=this.reposSc?.global_avg_speed.max


    this.avg_evo_sf_score=this.reposSc?.evolution_safety_score_chart?.avg
    this.evo_sf_scores=this.reposSc?.evolution_safety_score_chart?.evolution_safety_score.data
    this.evo_sf_score_cat=this.reposSc?.evolution_safety_score_chart?.evolution_safety_score.categories

    this.avg_evo_ec_score=this.reposSc?.evolution_eco_score_chart.avg
    this.evo_ec_scores=this.reposSc?.evolution_eco_score_chart?.evolution_eco_score.data
    this.evo_ec_score_cat=this.reposSc?.evolution_eco_score_chart?.evolution_eco_score?.categories



    this.getScore2(this.dist_moy, this.max_dis_moy,this.min_dis_moy)
    this.getScore3(this.vit_moy, this.max_vit_moy,this.min_vit_moy)
    //this.getGauge(this.vit_moy, this.max_vit_moy,this.min_vit_moy)



    this.getChartGauge(this.dist_moy, this.max_dis_moy, this.min_dis_moy, this.vit_moy, this.max_vit_moy,this.min_vit_moy )


    this.getchrt2(this.evo_ec_scores,this.evo_ec_score_cat,this.avg_evo_ec_score)

    this.getchrt3(this.evo_sf_scores,this.evo_sf_score_cat,this.avg_evo_sf_score)

//events type Repartition:



    //let result: any[] = [];
for (let i = 0; i < this.reposRepartitionTpEvents?.length; i++) {
   if (this.reposRepartitionTpEvents[i]?.value < 55) {
      this.result.push({"name": this.reposRepartitionTpEvents[i]?.name,"value": "#E05A61"});
   }
   else   if (this.reposRepartitionTpEvents[i]?.value < 75) {
    this.result.push({"name": this.reposRepartitionTpEvents[i]?.name,"value": "#FBB950"});
   }
   else   if (this.reposRepartitionTpEvents[i].value < 101) {
    this.result.push({"name": this.reposRepartitionTpEvents[i]?.name,"value": "#99CC00"});
 }
}
this.collection=[]
this.customColors = this.result;

var lgn:any = this.result.length
  this.lengthpage = parseInt("" + (lgn+ 1) / this.pageSize)


  //Create dummy data
  for (var i = 0; i < this.lengthpage+1; i++) {
    this.collection.push(i + 1);
  }

    this.unitsSF =[]
    this.scoresSF = []
    for (let U in this.reposRepartitionSF){


      this.unitsSF.push(this.reposRepartitionSF[U].units)
    this.scoresSF.push(this.reposRepartitionSF[U].interval+'%')

    //const
       if (this.reposRepartitionSF[U].avg_interval <50 ) {
        var style  = "verticalLines"
        var colors = '#E05A61'
      } else if (this.reposRepartitionSF[U].avg_interval <75 ) {
        var style  = "squares"
        var colors = '#FBB950'
      }else{
        var style  = "horizontalLines"
        var colors = '#51B373'
      }

      this.pieStyle.push(
        style


     );


     this.pieColors.push(
      colors);

    }

    this.getchrt1(this.unitsSF,this.pieStyle ,this.pieColors , this.reposRepartitionSF_avg ,this.scoresSF)



    this.unitsEC =[]
    this.scoresEC = []


    for (let U in this.reposRepartitionEC){

      this.unitsEC.push(this.reposRepartitionEC[U].units)
      this.scoresEC.push(this.reposRepartitionEC[U].interval+'%')
       if (this.reposRepartitionEC[U].avg_interval <50 ) {
        var style  = "verticalLines"
        var colors = '#E05A61'
      } else if (this.reposRepartitionEC[U].avg_interval <75 ) {
        var style  = "squares"
        var colors = '#FBB950'
      }else{
        var style  = "horizontalLines"
        var colors = '#51B373'
      }

      this.pieStyleEC.push(
        style


     );


     this.pieColorsEC.push(
      colors);

    }
    this.getchrt4(this.unitsEC,this.pieStyleEC ,this.pieColorsEC , this.reposRepartitionEC_avg ,this.scoresEC)


    this.Relation_unitsEC_SF =[]
    this.series11=[]
    for (let U in this.reposRelationSF_EC){

      this.Relation_unitsEC_SF.push(this.reposRelationSF_EC[U])

        this.series11.push([this.reposRelationSF_EC[U].eco_score,
          this.reposRelationSF_EC[U]?.safety_score,
           15,
           this.reposRelationSF_EC[U]?.id+"Name."+ this.reposRelationSF_EC[U]?.name,
        ]);

      this.getChrt(this.series11, this.RelationEC_Avg ,this.RelationSF_Avg)



      }
      this.spinnerVehiculeUser.hide();
  this.spinnerActive =false


 // this.typeEvenement =true

       },
       (error) => {
         Swal.fire({
           text: 'Un problème est survenu! '+error,

         })
         this.spinnerVehiculeUser.hide();
         this.spinnerActive =false
       })







     }













  displayedColumns: string[] = ['name', 'distance_traveled', 'trip_duration','avg_distance','avg_speed', 'safety_score','safety_score_tendency', 'diff_safety_score','km_between_maneuvers','nb_maneuvers' , 'eco_score','eco_score_tendency', 'diff_eco_score', 'idle_time'];
  // Assign the data to the data source for the table to render


pipe: DatePipe;

filterForm = new FormGroup({
  fromDate: new FormControl(),
  toDate: new FormControl(),
});

get fromDate() { return this.filterForm.get('fromDate').value; }
get toDate() { return this.filterForm.get('toDate').value; }

rangeFormGroup = new FormGroup({
  start: new FormControl(),
  end: new FormControl()

})
rangeFormGroup2 = new FormGroup({
  dt10: new FormControl(),


})





getChartGauge(distMoy , distMax ,distMin , vitesseMoy ,vitesseMax , VitesseMin){



 this.singleDistance = [
  {
    "name": "Distance Moyenne",
    "value": distMoy

  },

];
this.formatDist = (val)=>{


  return distMoy+'Km';
}



  this.minDist = distMin;
  this.maxDist= distMax;





 this.singleVitesse = [
  {
    "name": "Distance Moyenne",
    "value": vitesseMoy
  },

];
this.formatVitesse= (val)=>{


  return vitesseMoy+' Km/h';
}


   this.minVitesse = VitesseMin;
  this.maxVitesse= vitesseMax




}

  getScore2(e, max,min){
    this.chartOptions16 = {
      series: [
        {
          name: "Distance moyenne",
          data: [e]
        },

      ],
      chart: {
        type: "bar",
        height: 100,
        stacked: true,
        dropShadow: {
          enabled: true,
          blur: 1,
          opacity: 0.25
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "100%"
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 2
      },
      title: {
        text: "Distance moyenne"
      },
      xaxis: {
        categories: [''],
        min: 0,
        max: 100,
        tooltip: {
          enabled: true
        }
      },
      yaxis: {
        title: {
          text: undefined
        }
      },
      tooltip: {
        shared: false,
        y: {
          formatter: function(val) {
            return val + " Km";
          }
        }
      },
      fill: {
        type: "pattern",
        opacity: 1
      },
      states: {
        hover: {
          filter: {
            type: "none"
          }
        }
      },
      legend: {
        position: "right",
        offsetY: 40
      }
    };



  }

  getScore3(e,max,min){
    this.chartOptions17 = {
      colors:['#F44336'],
      series: [
        {
          name: "Vitesse moyenne",
          data: [e]
        },

      ],
      chart: {
        type: "bar",
        height: 100,
        stacked: true,
        dropShadow: {
          enabled: true,
          blur: 1,
          opacity: 0.25,

        },

      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "100%"
        }
      },
      markers: {
        colors: '#F44336',
     },
      dataLabels: {
        enabled: false,

      },
      stroke: {

        width: 2

      },
      title: {
        text: "Vitesse moyenne"
      },
      xaxis: {
        categories: [''],
        min: 0,
        max: 100
        , tooltip: {
          enabled: true
        }
      },
      yaxis: {
        title: {
          text: undefined
        }
      },
      tooltip: {
        shared: false,
        y: {
          formatter: function(val) {
            return val + "Km";
          }
        }
      },
      fill: {

        type: "pattern",
        opacity: 1
      },
      states: {
        hover: {
          filter: {
            type: "none"
          }
        }
      },
      legend: {
        position: "right",
        offsetY: 40
      }
    };



  }



getChrt(e ,ec ,sc){


  this.chartOptions =  {

    series: [

      {

        data:  e
      }
    ],
    chart: {
      height: 400,
      width:'100%',
      type: "bubble",
      events: {
        dataPointSelection:(event, chartContext, config) =>{

          this.router.navigate(['user/conducteur/details/'+this.series11[config.dataPointIndex][3].split('Name.')[0]]);
        },

    },
  },
    dataLabels: {
      enabled: false,

    },
    bubble: {
      minBubbleRadius: 10,
      maxBubbleRadius: 10,
    },
    fill: {
      opacity: 0.7
    },
    title: {
      text: ""
    },
    xaxis: {
      tooltip: {
        enabled: false
      },
      min:0,
      max: 100,

      type: "category",
      tickAmount:10,
      title: {
        text: 'score économie (%)',
        rotate: -90,
        offsetX: 0,
        offsetY: 0,
        style: {

            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 600,
            cssClass: 'apexcharts-yaxis-title',
        },
    }

    },
    annotations: {
      yaxis: [
        {
          y: sc,
          borderColor: '#ffcc36',
          label: {
            borderColor: '#ffcc36',
            style: {
              color: '#fff',
              background: '#ffcc36'
            },
            text: 'Y-axis moyenne '+sc+'%'
          }
        }
      ],
      xaxis: [
        {

          x: ec,
          borderColor: '#00E396',
          label: {
            borderColor: '#00E396',
            style: {
              color: '#fff',
              background: '#00E396'
            },
            text: 'X-axis moyenne '+ec+'%'
          }
        }
      ]
    },
    yaxis: {

      max: 100,
      title: {
        text: 'score securité (%)',
        rotate: -90,
        offsetX: 10,
        offsetY: 0,
        style: {

            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 600,
            cssClass: 'apexcharts-yaxis-title',
        },
    }
    },

tooltips: {

  enabled: true,

  onDatasetHover: {
    highlightDataSeries: false,
},
  x: {
    show: false,
    formatter:  (values)=> {
      this.xValues=values;
    }
  ,

 },
y: {

  formatter:  (values)=> {
    return  this.yValues=values;
  },
  title: {
    formatter: (seriesName,{ series, seriesIndex, dataPointIndex, w }) =>


    '<img src="https://img.icons8.com/color/20/000000/convertible-roof-warning.png"/> <b> conducteur : </b>  <b> '+this.series11[dataPointIndex][3].split('Name.')[1]+'</b><br/><hr>  <img src="https://img.icons8.com/color/20/000000/warning-shield.png"/> <b> Score de sécurité:</b>  ',


},
},
z: {
  formatter:  (values)=> {
    return  this.xValues  ;
  },

  title: '<img src="https://img.icons8.com/color/20/000000/natural-food.png"/> <b>Score économie :</b>'
},


}


}
}

 dbClickitem(e){
   let url = 'user/conducteur/details/'+e
   this.router.navigate([url]);


 }


getchrt4(e ,e1 ,e2,avg ,int_sc){

  this.chartOptions4 = {

    series:  e,
    colors: e2,

    chart: {
      width: "100%",
      height: "300px",
      type: "donut",
      dropShadow: {
        enabled: true,
        color: "#111",
        top: -1,
        left: 3,
        blur: 3,
        opacity: 0.2
      },
      toolbar: {
        show: true,

      }
    },
    stroke: {
      width: 0,

    },
    plotOptions: {
      pie: {
        startAngle: 0,
        expandOnClick: true,
        offsetX: 0,
        offsetY: 0,
        customScale: 1,
        dataLabels: {
            offset: 0,
            minAngleToShowLabel: 10
        },
        donut: {
          size: '65%',
          background: 'transparent',
          labels: {
            show: true,
           /*  name: {
              show: true,
              fontSize: '80px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              color: undefined,
              offsetY: -10,
              formatter: function (val) {
                return  avg +'%'
              }
            }, */
            value: {
              show: true,
              fontSize: '16px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 400,
              color: undefined,
              offsetY: 16,
              formatter: function (val) {
                return  avg +'%'
              }
            },
            total: {
              show: true,
              showAlways: false,
              label: "Moyenne",
              fontSize: '15px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              color: '#373d3f',
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => {
                  return  avg
                }, 0)+'%'
              }
            }
          }
        },
      }
    },
    tooltip: {
      enabled: true,
      onDatasetHover: {
        highlightDataSeries: true,
      },  marker: {
        show: false,
      },
      y: {

        formatter:  (values)=> {
          return  'Intervalle de score <img src="https://img.icons8.com/color/20/000000/accounting.png"/> Nombre des conducteurs: '+values ;
        },
      }
    },
    dataLabels: {
      enabled: true,

      dropShadow: {
        enabled: true,
        left: 2,
        top: 2,
        opacity: 0.5
    }
    },

    legend: {
      show: true,
        position: "bottom"



    }

    ,

    fill: {
      /* type: "pattern", */
      opacity: 1,
      colors: e2,
      pattern: {
        enabled: true,
        style: e1
      }
    },
    labels: int_sc,



    states: {
      title:' gfg',
      hover: {
        filter: {
          type: "none"
        }
      }
    },
    theme: {
      palette: "palette2"
    },
    title: {
      text: ""
    },


  };



}

  getchrt1(e ,e1 ,e2, avg ,int_sc){

    this.chartOptions2 = {

      series:  e,
      colors: e2,

      chart: {
        width: "100%",
        height: "300px",
        type: "donut",
        dropShadow: {
          enabled: true,
          color: "#111",
          top: -1,
          left: 3,
          blur: 3,
          opacity: 0.2
        },
        toolbar: {
          show: true,

        }
      },
      stroke: {
        width: 0
      },
      plotOptions: {
        pie: {
          startAngle: 0,
          expandOnClick: true,
          offsetX: 0,
          offsetY: 0,
          customScale: 1,
          dataLabels: {
              offset: 0,
              minAngleToShowLabel: 10
          },
          donut: {
            size: '65%',
            background: 'transparent',
            labels: {
              show: true,

              value: {
                show: true,
                fontSize: '16px',
                 fontWeight: 400,
                color: undefined,
                offsetY: 16,
                formatter: function (val) {
                  return avg +'%'
                }
              },
              total: {
                show: true,
                showAlways: false,
                label: "Moyenne",
                fontSize: '15px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                color: '#373d3f',
                formatter: function (w) {
                  return w.globals.seriesTotals.reduce((a, b) => {
                    return  avg
                  }, 0)+'%'
                }
              }
            }
          },
        }
      },

      dataLabels: {
        enabled: true,

        dropShadow: {
          enabled: true,
          left: 2,
          top: 2,
          opacity: 0.5
      }
      },

      legend: {
        show: true,
        position: "bottom"



      }

      ,

      fill: {
        /* type: "pattern", */
        opacity: 1,
        colors: e2,
        pattern: {
          enabled: true,
          style: e1
        }
      },
      labels: int_sc,


      states: {
        title:' gfg',
        hover: {
          filter: {
            type: "none"
          }
        }
      },
      theme: {
        palette: "palette2"
      },
      title: {
        text: ""
      },

      tooltip: {
        background: 'red',
        color: 'orange',
        enabled: true,
        onDatasetHover: {
          highlightDataSeries: true,
        },  marker: {
          show: false,
        },
        y: {

          formatter:  (values)=> {
            return  'Intervalle de score <img src="https://img.icons8.com/color/20/000000/accounting.png"/> Nombre des conducteurs: '+values ;
          },
        }
      },

    };

  }

  openSnackBar() {
    this._snackBar.open('Cannonball!!', 'End now', {
      duration: 500,

    });
  }

  applyFilterr() {
    this.dataSource.filter = ''+Math.random();
  }

 /*  getGauge(){

    this.canvasWidth = 300
    this.needleValue = 65
    this.centralLabel = ''
    this.name = 'Gauge chart'
    this.bottomLabel = '65'
    this.options_vit = {
      hasNeedle: true,
      needleColor: 'gray',
      needleUpdateSpeed: 1000,
      arcColors: ['rgb(44, 151, 222)', 'lightgray'],
      arcDelimiters: [65],
      rangeLabel: ['65', '65'],
      needleStartValue: 50,
    }


  } */
  rangeForm = new FormGroup({
    start: new FormControl(new Date(localStorage.getItem('startDateValue'))),
    end: new FormControl(new Date(localStorage.getItem('endDateValue'))),
  });

  executeFunction(){

       this.addNewDate(this.rangeForm)

     }
  addNewDate(e){



    var DateStart = new Date(e.value.start)?.toString().split('(')[0];


    //this.minDate = new Date(e.value.start)
     var DateEnd2 = new Date(e.value.end)?.toISOString();
     var DateEnd = new Date(e.value.end)?.toString().split('(')[0];

 if (DateEnd2 != "1970-01-01T00:00:00.000Z" ) {
  localStorage.setItem('startDateValue',new Date(this.rangeForm.value.start).toString())
  localStorage.setItem('endDateValue',new Date(this.rangeForm.value.end).toString())
  this.getdd(DateStart , DateEnd)
 } else {
  // this.rangeForm.reset();
 }




  }
  getFilter(){
    this.range =(<HTMLInputElement>document.getElementById('dateTime')).value
    var firstD ='9/23/2016'
    var firstT =this.range.split('~')[0].split(',')[1].split(' ')[1]
     var secondD = '9/23/2020'
    var secondT = this.range.split('~')[1].split(',')[1].split(' ')[1]
    var filterDT = firstD+'--'+secondD
    this.pipe = new DatePipe('en');
    var e =new Date(firstD).getUTCDate()
    this.filterValue =filterDT.replace(/\s/g, "")

    const defaultPredicate=this.dataSource.filterPredicate;



  }


  updateColor(progress) {
    if (progress<55){
       return '#dc3545';
    } else if (progress>75){
       return '#28a745';
    } else {
      return '#fd8021';
    }
 }
  getdd(e1 ,e2){

    this.rangeForm.setValue({
      start: new Date(localStorage.getItem('startDateValue')),
      end: new Date(localStorage.getItem('endDateValue'))
   });

this.result=[]
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
   // this.typeEvenement =false

    this.URL =  environment.apiUrl+"/companies/"+ JSON.parse(localStorage.getItem('currentUser')).company_id +"/scores/drivers/all/filter/"+e1+'~'+e2
    this.spinnerActive =true
    this.spinnerVehiculeUser.show();
    this.http.get(this.URL ,requestOptions).subscribe((response)=>{
      this.itemSelect= []

      this.hiddenDetails = false
      this.selectedRowIndex = -1;
      this.dataSource = new MatTableDataSource( this.listconducteure);

     // this.ELEMENT_DATAFILTER = JSON.stringify(response)
      var list:any =response
      this.dataSource = new MatTableDataSource(list.drivers);

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;


      this.reposSc=list


      this.reposRepartitionSF=list.repartition_safety_score_chart.repartition_safety_score
      this.reposRepartitionEC=list.repartition_eco_score_chart.repartition_eco_score
      this.reposRepartitionSF_avg=list.repartition_safety_score_chart.avg


      this.reposRepartitionEC_avg=list.repartition_eco_score_chart.avg


//events type Repartition:

this.reposRepartitionTpEvents=list?.global_repartition_events

var dataarray :any = []  ;
this.reposRepartitionTpEvents.filter(obj => {
dataarray.push(obj.value)
}  )
var namearray:any = [] ;
this.reposRepartitionTpEvents.filter(obj =>  {
namearray.push(obj.name)
}  )


this.chartOptionds= {
  series: [
    {
      name: "My-series",
      data: dataarray
    }
  ],
  chart: {
    height: 400,
    type: "bar",
    width: '100%',
    dropShadow: {
      enabled: true,
      color: "#000",
      top: 18,
      left: 7,
      blur: 10,
      opacity: 0.2
    },
    toolbar: {
      show: true
    }
  },
  colors:  ["#51B373"],
  // title: {
  //   text: "Répartition des types d'évènement"
  // },
  xaxis: {
    categories: namearray
  },
  markers: {
    size: 6,
    hover: {
      size: 16
    }
  },
};


       //Relation Safety-Economy score

 this.reposRelationSF_EC=list.safety_eco_relation.relation
 this.RelationEC_Avg=list.safety_eco_relation.avg_eco_score
 this.RelationSF_Avg=list.safety_eco_relation.avg_safety_score

this.scoreS=this.reposSc?.global_safety_score
this.scoreEc=this.reposSc?.global_eco_score
this.distanceEntreMan= this.reposSc?.global_km_between_maneuvers
this.tmpinactivite =this.reposSc?.global_idle_time
this.sc_tnd_eco=this.reposSc?.global_eco_score_tendency
this.sc_tnd_sec=this.reposSc?.global_safety_score_tendency

this.dist_moy=this.reposSc?.global_avg_distance?.avg_distance
this.min_dis_moy=this.reposSc?.global_avg_distance?.min
this.max_dis_moy=this.reposSc?.global_avg_distance?.max

this.vit_moy=this.reposSc?.global_avg_speed?.avg_speed
this.min_vit_moy=this.reposSc?.global_avg_speed?.min
this.max_vit_moy=this.reposSc?.global_avg_speed?.max


this.avg_evo_sf_score=this.reposSc.evolution_safety_score_chart.avg
this.evo_sf_scores=this.reposSc.evolution_safety_score_chart.evolution_safety_score.data
this.evo_sf_score_cat=this.reposSc.evolution_safety_score_chart.evolution_safety_score.categories

this.avg_evo_ec_score=this.reposSc.evolution_eco_score_chart.avg
this.evo_ec_scores=this.reposSc.evolution_eco_score_chart.evolution_eco_score.data
this.evo_ec_score_cat=this.reposSc.evolution_eco_score_chart.evolution_eco_score.categories



this.getScore2(this.dist_moy, this.max_dis_moy,this.min_dis_moy)
this.getScore3(this.vit_moy, this.max_vit_moy,this.min_vit_moy)
this.getchrt3(this.evo_sf_scores,this.evo_sf_score_cat,this.avg_evo_sf_score)
this.getchrt2(this.evo_ec_scores,this.evo_ec_score_cat,this.avg_evo_ec_score)
this.getChartGauge(this.dist_moy, this.max_dis_moy, this.min_dis_moy, this.vit_moy, this.max_vit_moy,this.min_vit_moy )
this._snackBar.open('Filtrage par  date effectuer'+e1+' à '+e2, 'Fermer', {
  duration: 2500,

});



//let result: any[] = [];
for (let i = 0; i < this.reposRepartitionTpEvents?.length; i++) {
   if (this.reposRepartitionTpEvents[i]?.value < 55) {
      this.result.push({"name": this.reposRepartitionTpEvents[i]?.name,"value": "#E05A61"});
   }
   else   if (this.reposRepartitionTpEvents[i]?.value < 75) {
      this.result.push({"name": this.reposRepartitionTpEvents[i]?.name,"value": "#FBB950"});
   }
   else   if (this.reposRepartitionTpEvents[i]?.value < 101) {
    this.result.push({"name": this.reposRepartitionTpEvents[i]?.name,"value": "#51B373"});
 }
}

this.customColors = this.result;

this.unitsSF =[]
this.scoresSF = []
for (let U in this.reposRepartitionSF){

  this.unitsSF.push(this.reposRepartitionSF[U].units)
  this.scoresSF.push(this.reposRepartitionSF[U].interval+'%')

   if (this.reposRepartitionSF[U].avg_interval <50 ) {
    var style  = "verticalLines"
    var colors = '#E05A61'
  } else if (this.reposRepartitionSF[U].avg_interval <75 ) {
    var style  = "squares"
    var colors = '#FBB950'
  }else{
    var style  = "horizontalLines"
    var colors = '#51B373'
  }

  this.pieStyle.push(
    style


 );


 this.pieColors.push(
  colors);

}


this.unitsEC =[]
this.scoresEC = []


for (let U in this.reposRepartitionEC){

  this.unitsEC.push(this.reposRepartitionEC[U].units)
  this.scoresEC.push(this.reposRepartitionEC[U].interval+'%')
   if (this.reposRepartitionEC[U].avg_interval <50 ) {
    var style  = "verticalLines"
    var colors = '#E05A61'
  } else if (this.reposRepartitionEC[U].avg_interval <75 ) {
    var style  = "squares"
    var colors = '#FBB950'
  }else{
    var style  = "horizontalLines"
    var colors = '#51B373'
  }

  this.pieStyleEC.push(
    style


 );


 this.pieColorsEC.push(
  colors);

}
this.getchrt4(this.unitsEC,this.pieStyleEC ,this.pieColorsEC , this.reposRepartitionEC_avg ,this.scoresEC)
this.getchrt1(this.unitsSF,this.pieStyle ,this.pieColors , this.reposRepartitionSF_avg ,this.scoresSF)



this.Relation_unitsEC_SF =[]
this.series11=[]
for (let U in this.reposRelationSF_EC){

  this.Relation_unitsEC_SF.push(this.reposRelationSF_EC[U])

   for (let i in this.Relation_unitsEC_SF ) {

    this.series11.push([this.reposRelationSF_EC[U].eco_score,
      this.reposRelationSF_EC[U]?.safety_score,
       15,

        this.reposRelationSF_EC[U]?.id+"Name."+ this.reposRelationSF_EC[U]?.name,
    ]);
  }

  this.getChrt(this.series11, this.RelationEC_Avg ,this.RelationSF_Avg)



  }
  this.spinnerVehiculeUser.hide();
  this.spinnerActive =false
 // this.typeEvenement =true

  },
  (error) => {
    Swal.fire({
      text: 'Un problème est survenu! '+error,

    })
    this.spinnerVehiculeUser.hide();
    this.spinnerActive =false
  })











  }






  getFilterChoise(filterdte){
    this.rangeForm.reset();
    (<HTMLInputElement>document.getElementById('getdt')).value =''

  const headerDict = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
  }

  const requestOptions = {
    headers: new HttpHeaders(headerDict),
  };

  this.pipe = new DatePipe('en');
  this.days =  this.pipe.transform(new Date(),'M/d/yyyy');

  var date = new Date();
   date.setDate(date.getDate() - filterdte);

 this.finalDate =  (date.getMonth()+1) +'/'+ date.getDate()+'/'+date.getFullYear();
 var periodeFilter = date.toString().substr(0, 24)+'~'+(new Date).toString().substr(0, 24)
 localStorage.setItem('startDateValue', new Date(date).toString());
 localStorage.setItem('endDateValue', new Date().toString());
 this.getdd(date.toString().substr(0, 24) , (new Date).toString().substr(0, 24))



  }



  selectedRowIndex = -1;

  getItemDetails(e){
    this.itemSelect =e;
    this.selectedRowIndex = e.id;

    this.hiddenDetails = true
  }

  selectedRowIndex2 = -1;

  getItemDetails2(e){
    this.itemSelect2 =e.forks;

this.selectedRowIndex2 = e.id;
this.hiddenContenu ='jkhjk';


  }
gettbldetils(){
  this.tblhidden = 'true';
}
gettbldetilsd(){
  this.tblhidden = 'jjj';
}
  // MatPaginator Output
  pageEvent: PageEvent;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions1 = setPageSizeOptionsInput.split(',').map(str => +str);

    }

  }




public updateManualPage(index): void {
  this.pageNum =index
  this.manualPage = index;
  this.paginator.pageIndex = index;

  this.paginator.page.next({
    pageIndex: this.paginator.pageIndex,
    pageSize: this.paginator.pageSize,
    length: this.paginator.length
  });


}


collection:any ;

public updateManualPage2(index2): void {
this.collection=[]

this.paginator.pageSize = index2

this.paginator.page.next({
  pageIndex: this.paginator.pageIndex,
  pageSize: this.paginator.pageSize,
  length: this.paginator.length
});



this.lengthpage = parseInt(""+this.paginator.length/index2)

 //Create dummy data
 for (var i = 0; i < this.lengthpage; i++) {
  this.collection.push(i+1);
}

}

  applyFilterer(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
      this.dataSource.sort = this.sort;

    }



  }

  exportExcel(e ,e2) {


    Swal.fire({
      title: 'Souhaitez-vous exporter la table ?',
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: 'Démarrer l\'exportation!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Export!',
          'Le fichier est exporté'
        )
        e.exportTable(e2 ,{fileName:'STG_DRIVE_Conducteur_date_'+new Date().toLocaleString() ,sheet: 'STG DRIVE Conducteur',Props:{'Author' :'STG_DRIVE'}})

      } else if (result.dismiss === Swal.DismissReason.cPDFfileancel) {
        Swal.fire(
          'Annulé',
          'Fichier non exporté !!',
        )
      }
    })

}


exportTable(){

  Swal.fire({
    title: 'Souhaitez-vous exporter la table ?',
    showCancelButton: true,
    confirmButtonColor: '#262756',
    cancelButtonColor: "#e05a61",
    confirmButtonText: 'Démarrer l\'exportation',
    cancelButtonText: 'Annuler'
  }).then((result) => {
    if (result.value) {


      PDFfile.exportToPdf("ExampleTable","tbl");

} else if (result.dismiss === Swal.DismissReason.cancel) {
  Swal.fire(
    'Annulé',
    'Fichier non exporté !!'
  )
}
})

}







}




export interface PeriodicElementfilter {
  name: string;
  position: number;
  weight: number;
  weight1: number;
  weight2: number;
  pushed_at: Date;
  created_at: Date;
}

